import { Button, Icons, Modal } from "@pankod/refine-antd";
import { MermaidView } from "components/common/mermaidView";
import { IState } from "interfaces";
import { statesToMermaid } from "scripts/site";
import { getAppTheme } from "scripts/theme";

export const RenderWorkflowModal: React.FC<IState[]> = (entityStates) => {
    function WorkflowModal(dataContent: any) {
        const modal = Modal.info({
            title: 'Workflow ',
            icon: <Icons.ApartmentOutlined />,
            content: dataContent,
            width: '80%',
            className: `hstrymdl ${getAppTheme()}`,
            maskClosable: true,
            closable: true,
            onOk() { modal.destroy() }
        });
    }
    return (
        <Button
            className="hst"
            title="View Workflow"
            icon={<Icons.ApartmentOutlined />}
            onClick={() => {
                WorkflowModal(
                    <MermaidView placeholderId="hstrymrmadmdl" graphDefinition={statesToMermaid(entityStates)}></MermaidView>
                );
            }}
        >
        </Button>
    );
};